module.exports = __webpack_public_path__ + "img/icon-edit_gold.7373c4ff.svg";